import React from 'react';
import PanelIcon from '@mui/icons-material/Bookmarks';

export default [
  {
    name: 'Name',
    sort: 'name',
    selector: row => row.name,
    sortable: true,
    grow: 3,
    cell: (row) => {
      return (
        <>
          <PanelIcon fontSize='large' /> {row.name}
        </>
      );
    },
  },
  {
    name: 'Organization',
    sort: 'organization.name',
    selector: row => row.organization.name,
    sortable: true,
    grow: 2,
    cell: (row)=>{
      return (
        <>
          {row.organization? row.organization.name: "N/A"}
        </>
      )
    }
  },
  {
    name: 'Lab Panel ID',
    sort: 'externalId',
    selector: row => row.externalId,
    sortable: true,
    grow: 1,
  },
  {
    name: 'Active',
    sort: 'active',
    selector: row => row.active,
    sortable: true,
    width: '100px',
    cell: (row) => {
      return row.active ? 'Yes' : 'No';
    },
  },
];